import React, { useState } from "react";
import Modal from "react-modal";
import Styles from "./add.module.css";
import { FaFolder } from "react-icons/fa";
import { FileUploader } from "react-drag-drop-files";
import { bulkuploadDemo } from "Services";
import ReactLoading from "react-loading";
import { Services } from "Services";
import Mainloader from "../../../../Components/loader/loader";
import { IoMdClose } from "react-icons/io";
import { Success } from "Util/Toast";
import { IoFileTray } from "react-icons/io5";
window.Buffer = window.Buffer || require("buffer").Buffer;
function Add({ shwoModal, setModal }) {
    const [uploadProgress, setUploadProgress] = useState(0);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [file, setFile] = useState("");
    const [load, setLoad] = useState(false);
    const [Mainload, setMainLoad] = useState(false);
    const fileTypes = ["XLS", "XLSX"];

    function filehandleChange(files) {
        setFile(files);
    }
    const fileuploadDesign = (
        <div className={Styles["add-item"]}>
            <FaFolder className={Styles["upload-icon"]} />
            <h5>Drag & Drop Your Files here</h5>
        </div>
    );
    const submitHandler = () => {
        setMainLoad(true);
        let formData = new FormData();
        formData.append("file", file);
        Services.bulkuploadDemo("POST", formData, token)
            .then((response) => {
                console.log(response);
                setModal(false);
                setTimeout(() => {
                    setMainLoad(false);
                }, 200);
                if (response.Status === 1) {
                    Success(response.Message);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setMainLoad(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const closehandler = () => {
        setModal(false);
        setLoad(false);
        setFile("");
    };
    return (
        <div>
            {Mainload && <Mainloader />}

            <Modal
                isOpen={shwoModal}
                contentLabel="Modal"
                className={Styles["modal"]}
                overlayClassName={Styles["overlay"]}>
                <div className={Styles["wrapper"]}>
                    <header>
                        <h3>Upload Excel File</h3>
                        <button onClick={closehandler}>
                            <IoMdClose />
                        </button>
                    </header>
                    <div className={Styles["file-upload"]}>
                        <div className={Styles["file-upload-wrapper"]}>
                            <FileUploader
                                classes={FileUploader["upload-image"]}
                                multiple={false}
                                handleChange={filehandleChange}
                                name="file"
                                children={fileuploadDesign}
                                // types={fileTypes}
                                types={fileTypes}
                            />
                        </div>
                        {file && (
                            <div className={Styles["uploadedFilePreview"]}>
                                <p>
                                    <IoFileTray
                                        style={{ marginRight: "8px" }}
                                    />
                                    {file.name}
                                </p>
                                <button
                                    onClick={() => {
                                        const fileURL =
                                            URL.createObjectURL(file);
                                        window.open(fileURL, "_blank");
                                    }}
                                    className={Styles["viewFileBtn"]}>
                                    Open File
                                </button>
                            </div>
                        )}
                    </div>
                    <div className={Styles["actionHandler"]}>
                        {load ? (
                            <ReactLoading
                                color="green"
                                type="spokes"
                                height={30}
                                width={30}
                            />
                        ) : (
                            <button onClick={submitHandler}>Upload</button>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default Add;
